/** Imports */
import {type Platform} from '@/mongoSchemas/Page/Pages.zod';


/** Types */
export type PostCreatorFeedbackMessage = Readonly<{
    message: string;
    platform?: Platform;
}>;


/** Helpers */
export function postCreatorFeedbackMessage(
    message: string,
    platform?: Platform,
): PostCreatorFeedbackMessage {
    if (platform) {
        return {message, platform};
    }
    return {message};
}

export function dedupePostCreatorFeedbackMessages(
    messages: Array<PostCreatorFeedbackMessage>,
): Array<PostCreatorFeedbackMessage> {
    const seen = new Set<string>();
    return messages.filter((message) => {
        const key = `${message.platform ?? 'global'}:${message.message}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
    });
}
